import { gap, spacing } from '@lamimed/pantheon';
import styled, { css } from 'styled-components';

interface TextContainerProps {
  margin?: 'small' | 'medium' | 'large';
  opactity?: string;
}

interface FieldContainerProps {
  error: boolean;
}

const marginVariants = {
  small: spacing.small,
  medium: spacing.medium,
  large: spacing.large,
};

export const FormWrapper = styled.form``;

export const TextContainer = styled.div<TextContainerProps>`
  margin: 0 0 ${(props) => (props.margin ? marginVariants[props.margin] : 0)} 0;
  opacity: ${(props) => props.opactity};
`;

export const StepperContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: ${spacing.medium} 0 0 0;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin: ${spacing.medium} 0;
  ${gap(spacing.medium)};
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FieldContainer = styled.div<FieldContainerProps>`
  ${({ error }) => css`
    margin: 0 0 ${error ? `3rem` : spacing.medium} 0;
  `};
`;
